<template>
  <div class="withdraw-record-page">
    <!-- 顶部导航 -->
    <header class="header">
      <div class="header-back" @click="back()">
        <van-icon name="arrow-left" />
      </div>
      <h1 class="header-title">{{ $t('my.withdraw_record') || '提現記錄' }}</h1>
      <div class="header-placeholder"></div>
    </header>

    <!-- 表格标题 -->
    <div class="table-header">
      <div class="col col-date">{{ $t('my.change_date') }}</div>
      <div class="col col-amount">{{ $t('my.change_money') }}</div>
      <div class="col col-status">{{ $t('my.status') || '狀態' }}</div>
      <div class="col col-detail">{{ $t('my.detail') || '詳情' }}</div>
    </div>

    <!-- 拉刷新 -->
    <van-pull-refresh v-model="isLoading" @refresh="getUserWithdrawList">
      <!-- 记录列表 -->
      <div v-if="list.length === 0" class="empty-state">
        <van-empty :description="$t('withdraw.empty_data') || '沒有記錄'" />
      </div>

      <div v-else class="record-list">
        <div
          v-for="(record, index) in list"
          :key="index"
          class="record-item"
        >
          <div class="col col-date">
            <span class="date-text">{{ record.create_time }}</span>
          </div>
          <div class="col col-amount">
            <span class="amount-text">{{ record.money }}HKD</span>
          </div>
          <div class="col col-status">
            <span :class="['status-text', getStatusClass(record.status)]">
              {{ record.status_text || getStatusText(record.status) }}
            </span>
          </div>
          <div class="col col-detail">
            <van-icon
              name="arrow-down"
              class="expand-icon"
              :class="{ 'expand-open': expandedIndex === index }"
              @click="toggleExpand(index)"
            />
          </div>

          <!-- 展开详情 -->
          <div v-if="expandedIndex === index" class="record-detail">
            <div class="detail-row">
              <span class="detail-label">{{ $t('withdraw.order_no') || '訂單號' }}:</span>
              <span class="detail-value">{{ record.id || 'N/A' }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">{{ $t('withdraw.withdraw_time') || '提現時間' }}:</span>
              <span class="detail-value">{{ record.create_time || 'N/A' }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">{{ $t('withdraw.withdraw_amount') || '提現金額' }}:</span>
              <span class="detail-value">{{ record.money || 'N/A' }}HKD</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">{{ $t('my.status') || '狀態' }}:</span>
              <span :class="['detail-value', getStatusClass(record.status)]">{{ record.status_text || getStatusText(record.status) }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">{{ $t('withdraw.remark_info') || '備註資訊' }}:</span>
              <span class="detail-value">{{ record.remark || record.desc || record.fail_reason || 'N/A' }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">{{ $t('withdraw.bank_name') || '金融卡名稱' }}:</span>
              <span class="detail-value">{{ bankInfo.bankinfo }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">{{ $t('withdraw.bank_branch') || '金融卡支行' }}:</span>
              <span class="detail-value">{{ bankInfo.bankfenhang }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">{{ $t('withdraw.bank_card') || '金融卡' }}:</span>
              <span class="detail-value">{{ bankInfo.bankid }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">{{ $t('withdraw.user_name') || '使用者名稱' }}:</span>
              <span class="detail-value">{{ bankInfo.username }}</span>
            </div>
          </div>
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: [],
      bankInfo: {},
      expandedIndex: -1
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    toggleExpand(index) {
      this.expandedIndex = this.expandedIndex === index ? -1 : index;
    },
    getStatusClass(status) {
      if (status === 2 || status === 4) {
        return 'success';
      }
      if (status === 3) {
        return 'failed';
      }
      return 'pending';
    },
    getStatusText(status) {
      const statusMap = {
        1: '待審核',
        2: '已批准',
        3: '已拒絕',
        4: '已完成'
      };
      return statusMap[status] || '未知狀態';
    },
    getUserWithdrawList() {
      this.isLoading = true;
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_list'
      }).then(res => {
        if (res.code === 200) {
          this.list = res.data2.list || [];
          this.bankInfo = res.data2.bankinfo;
          console.log(this.bankInfo)
        } else if (res.code === 401) {
          this.$toast(res.msg);
          this.$router.push({ path: '/Login' });
        } else {
          this.$toast(res.msg || 'Failed to load records');
        }
        this.isLoading = false;
      })
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.getUserWithdrawList();
    }
  }
};
</script>

<style lang="less" scoped>
.withdraw-record-page {
  min-height: 100vh;
  background: #151515;
  color: #f5f5f5;
  padding-bottom: 80px;
}

/* 头部 */
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #151515;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.header-back {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 32px;
  color: #fff;
}

.header-title {
  flex: 1;
  text-align: center;
  font-size: 30px;
  font-weight: 700;
  color:#22cc61;
  margin: 0;
}

.header-placeholder {
  width: 40px;
}

/* 表格 */
.table-header {
  display: grid;
  grid-template-columns: 0.8fr 1.2fr 1.2fr 0.8fr;
  gap: 12px;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.05);
  font-size: 24px;
  font-weight: 600;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.col {
  display: flex;
  align-items: center;
  justify-content: center;
}

.col-date {
  justify-content: flex-start;
  text-align: left;
}

.col-amount {
  justify-content: center;
}

.col-status {
  justify-content: center;
}

.col-detail {
  justify-content: center;
}

/* 记录列表 */
.record-list {
  padding: 0;
}

.record-item {
  display: grid;
  grid-template-columns: 0.8fr 1.2fr 1.2fr 0.8fr;
  gap: 12px;
  padding: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  align-items: center;
}

.record-item:active {
  background: rgba(255, 255, 255, 0.02);
}

.date-text {
  font-size: 24px;
  color: #ccc;
  word-break: break-all;
}

.amount-text {
  font-size: 24px;
  color: #fff;
  font-weight: 500;
}

.status-text {
  font-size: 24px;
  font-weight: 500;

  &.success {
    color: #22cc61;
  }

  &.pending {
    color: #ffaa00;
  }

  &.failed {
    color: #ff4444;
  }
}

.expand-icon {
  cursor: pointer;
  font-size: 16px;
  color: #888;
  transition: transform 0.3s;

  &.expand-open {
    transform: rotate(180deg);
  }
}

/* 展开详情 */
.record-detail {
  grid-column: 1 / -1;
  margin-top: 8px;
  // border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 24px;
  padding: 8px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  &:last-child {
    border-bottom: none;
  }
}

.detail-label {
  color: #fff;
  font-weight: 500;
  min-width: 80px;
  padding:0 20px;
}

.detail-value {
  color: #fff;
  text-align: right;
  flex: 1;
  word-break: break-all;
	padding:0 20px;
  &.positive {
    color: #fff;
  }

  &.negative {
    color: #ff4444;
  }
}
/* 空状态 */
.empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  padding: 40px 16px;
}
</style>
